/**
 * @generated SignedSource<<99f4af06f8166928be40f1f8e7bcbbff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespUnavailableDetailsTabs_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedSellerDetails_viewer">;
  readonly " $fragmentType": "PdpRespUnavailableDetailsTabs_viewer";
};
export type PdpRespUnavailableDetailsTabs_viewer$key = {
  readonly " $data"?: PdpRespUnavailableDetailsTabs_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespUnavailableDetailsTabs_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespUnavailableDetailsTabs_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedSellerDetails_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "2dcd2859b16e6d81235d357438895061";

export default node;
